module.exports = __webpack_public_path__ + "img/1.89d60438.jpg";